import { expectAtIndex } from "@aprao/common/src/array/expectAtIndex.js";
import { expectNotUndefined } from "option-t/undefinable";

const getCurrencyPartValue = (
  locale: Intl.LocalesArgument,
  options: Intl.NumberFormatOptions,
) =>
  expectAtIndex(
    new Intl.NumberFormat(locale, {
      style: "currency",
      ...options,
    })
      .formatToParts(0)
      .filter(({ type }) => type === "currency"),
    0,
  ).value;

export const getCurrency = <TCode extends string>(
  locale: Intl.LocalesArgument,
  code: TCode,
) => ({
  code,
  name: expectNotUndefined(
    new Intl.DisplayNames(locale, { type: "currency" }).of(code),
    "The currency name property can not be undefined",
  ),
  narrowSymbol: getCurrencyPartValue(locale, {
    currency: code,
    currencyDisplay: "narrowSymbol",
  }),
  symbol: getCurrencyPartValue(locale, {
    currency: code,
    currencyDisplay: "symbol",
  }),
});
